// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error.error-3 .error-title{font-size:8.7rem!important}@media(min-width:768px){.error.error-3 .error-title{font-size:15.7rem!important}}", ""]);
// Exports
module.exports = exports;
